import React, { useState, useEffect, Fragment, useContext } from "react";
import { useTranslation } from "react-i18next";
import logo from '../../assets/img/logo/logo-smart.png';
import { Link } from "react-router-dom";
import { TelephoneFill, List } from 'react-bootstrap-icons';
import { IsNotNull } from "../common/helpers";
import Sidebar from "../navigation/Sidebar";
import { DropdownButton } from "../dropdowns/DropdownButton";
import styles from '../../assets/css/module/common/common.module.css'
import ContactUsWA from '../../components/contact/contact-us-wa';
import { contextValues } from "../context/context-master";

import { LANGUAGES } from '../../language/language-list';
const Header = () => {
  const { nav, setNav, language, setLanguage } = useContext(contextValues);
  const [MenuSelected, setMenuSelected] = useState('home');
  const [languageSelected, setLanguageSelected] = useState('en');
  const [sidebaropen, toggleSidebar] = useState(false);
  const [modalWA, setModalWA] = useState(false)
  const [optionsLanguage, setOptionsLanguage] = useState([])

  const { i18n, t } = useTranslation();

  const toggleWA = () => setModalWA(!modalWA);

  function getOptionsLanguage() {
    let options = []
    LANGUAGES.map(x => 
      options.push({
        v: x.code,
        icon: x.icon,
        tooltip: x.label,
      })
    )
    setOptionsLanguage(options)
  }

  const toggleMenu = (x) => {
    setMenuSelected(x)
    setNav(x)
    localStorage.setItem('nav', x)
  }

  const [WD, setWD] = useState(window.innerWidth);
  useEffect(() => {
    window.addEventListener("resize", () => setWD(window.innerWidth));
    return () => {
      window.removeEventListener("resize", () => setWD(window.innerWidth));
    };
  }, [WD]);

  useEffect(() => {
    setMenuSelected(nav)
  }, [nav]);

  useEffect(() => {
    setLanguageSelected(language)
  }, [language]);


  useEffect(() => {
    checkNavLocalStorage()
    checkLangLocalStorage()
    getOptionsLanguage()
  }, []);

  function checkNavLocalStorage() {
    let l_nav = localStorage.getItem('nav')
    if (IsNotNull(l_nav)) {
      if (l_nav !== nav) {
        setNav(l_nav)
        setMenuSelected(l_nav)
      }
    }
  }

  function checkLangLocalStorage() {
    let l = language
    try {
      l = localStorage.getItem('language')
    } catch (error) {
      console.log(error);
    } finally {
      if (IsNotNull(l)) {
        setLanguage(l)
        setLanguageSelected(l)
        i18n.changeLanguage(l);
      }
    }
  }

  return (
    <Fragment>
      <div className={`${styles["sec-top-nav-bar"]}`}>
        <div className={`${styles["layout-center"]}`}>
          <header className={`${styles["header"]}`}>
            <img src={logo} alt='logo' className={`${styles["logo-top-nav-bar"]}`} />
            <nav className={`${styles["top-navbar"]}`}>
              <ul className={`${styles["top-navbar-list-menu"]}`}>
                <li className={`${styles["top-navbar-menu"]} ${MenuSelected === 'home' ? styles["nav-active"] : ''}`}>
                  <Link to={'/home'} onClick={() => toggleMenu('home')}>{t("home")}</Link>
                </li>
                <li className={`${styles["top-navbar-menu"]} ${MenuSelected === 'news' ? styles["nav-active"] : ''}`}>
                  <Link to={'/news'} onClick={() => toggleMenu('news')}>{t("news")}</Link>
                </li>
                <li className={`${styles["top-navbar-menu"]} ${MenuSelected === 'career' ? styles["nav-active"] : ''}`}>
                  <Link to={'/career'} onClick={() => toggleMenu('career')}>{t("career")}</Link>
                </li>
                <li className={`${styles["top-navbar-menu"]} ${MenuSelected === 'faq' ? styles["nav-active"] : ''}`}>
                  <Link to={'/faq'} onClick={() => toggleMenu('faq')}>FAQ</Link>
                </li>
                <li className={`${styles["top-navbar-menu"]} ${MenuSelected === 'about' ? styles["nav-active"] : ''}`}>
                  <Link to={'/about'} onClick={() => toggleMenu('about')}>{t("about_us")}</Link>
                </li>
              </ul>
            </nav>

            <div className={`${styles['flx-c']} ${styles['header-right-sec']} `}>
              <DropdownButton
                values={optionsLanguage}
                label={language}
              />
              <button className={`${styles["header-contact-us-btn"]} ${styles["btn"]}`} onClick={() => toggleWA()}><TelephoneFill />{t('Contact Us')}</button>
            </div>

            {
              WD < 720 ? <div className={`${styles["top-navbar-burger-menu"]}`} onClick={() => toggleSidebar(!sidebaropen)}>
                <List />
              </div> : null
            }
            {
              sidebaropen ? <Sidebar sidebaropen={sidebaropen} toggleSidebar={toggleSidebar} /> : null
            }
          </header>
        </div>
      </div>
      {
        modalWA ?
          <ContactUsWA
            modal={modalWA}
            toggleHandler={toggleWA}
          /> : null
      }
    </Fragment>
  )
}

export default Header;